import { EnvironmentInjector, inject } from '@angular/core';

import { LazyComponentDetails } from '@core/shared/util';
import { LoginContextService } from '@mpk/shared/data-access';
import { SettingsFormPlugin, SettingsFormPluginComponent } from '@mpk/shared/util';

import { DocumentManagementOrganizationSettingsPermissions } from '../permissions';

/**
 * Factory to create the Purchase Requisition organization settings plugin.
 */
export function createPurchaseRequisitionOrganizationSettingsPlugin(): SettingsFormPlugin {
  const loginContextService = inject(LoginContextService);

  return {
    settingsId: 'PurchaseRequisitionOrganizationSettings',
    displayName: 'Anforderungen',
    description: 'Hier werden alle Anforderungseinstellungen vorgenommen.',
    isEnabled: loginContextService.permission(DocumentManagementOrganizationSettingsPermissions.ManageSettings),
    async getComponentDetails(
      parentInjector: EnvironmentInjector,
    ): Promise<LazyComponentDetails<SettingsFormPluginComponent>> {
      const { PurchaseRequisitionOrganizationSettingsEditComponent } = await import('../pages');

      return {
        component: PurchaseRequisitionOrganizationSettingsEditComponent,
        environmentInjector: parentInjector,
      };
    },
  };
}
